import React from 'react'
import { useState } from 'react'
import { collection, getDoc, getDocs, query, serverTimestamp, setDoc, updateDoc, where, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const Search = () => {
    const [username, setUsername] = useState("")
    const [user, setUser] = useState(null)
    const [err, setErr] = useState(false)

    const {currentUser} = useContext(AuthContext)

    const handleSearch = async () => {
      const q = query(
        collection(db, "users"),
        where("displayName", "==", username)
      );

    try {
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        setUser(doc.data())
      });
    } catch(err){
        setErr(true);
    }
    };
    

    const handleKey = (e) => {
        e.code === "Enter" && handleSearch();
    };

    const handleSelect = async () => {
        const combinedId = currentUser.uid > user.uid
         ? currentUser.uid + user.uid
         : user.uid + currentUser.uid;
        try {
        const res = await getDoc(doc(db, "chats", combinedId));

        if(!res.exists()){
            await setDoc(doc(db, "chats", combinedId),{messages: [] })

            await updateDoc(doc(db, "userChats", currentUser.uid),{
                [combinedId+".userInfo"]: {
                    uid: user.uid,
                    displayName: user.displayName,
                    photoURL: user.photoURL
                },
                [combinedId+".date"]: serverTimestamp()
            });

            await updateDoc(doc(db, "userChats", user.uid),{
                [combinedId+".userInfo"]: {
                    uid: currentUser.uid,
                    displayName:currentUser.displayName,
                    photoURL:currentUser.photoURL
                },
                [combinedId+".date"]: serverTimestamp()
            });
        }

        }catch (err) {}

        setUser(null);
        setUsername("");
    }

  return (
    <div className='search'>
        <div className="searchForm">
            <input type="text" placeholder='Find a user'
             onKeyDown={handleKey}
            onChange={e=>setUsername(e.target.value)}
            value={username}
            />
        </div>
        {err && <span>User not found</span>}
        {user && <div className="userChat" onClick={handleSelect}>
            <img src={user.photoURL} alt="" />
            <div className="userChatInfo">
                <span>{user.displayName}</span>
            </div>
        </div>}
    </div>
  )
}

// https://scontent-sjc3-1.xx.fbcdn.net/v/t39.30808-6/341046185_616678886659832_4411970842948082997_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=ROpbTwZq6XIAX9AXFhs&_nc_oc=AQlfnLZSpmSUaGLT03SYYHIhuTUvRmnksT-Cc_Y2o3N54N_jSV5_LLpG74u2SZpzXbw&_nc_ht=scontent-sjc3-1.xx&oh=00_AfCT9ifJhawjYn_tlEuzA2785-G3mNbYt1VQY8DHkuSHvw&oe=6444BADA

export default Search